import React from 'react';
import _ from 'lodash';
import { menuItems } from './config';
import { updateUserTheme } from 'v3/common/api/user';
import { supportConfig } from 'v3/layout/footer/Default/config';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const Body: React.FC = () => {
  const { isAdmin, isUserSignedIn, isAlgoverse, isB2b } = ApplicationDomainUtility;

  const currentUserTheme = window.currentTheme;
  const [shouldShowMultipleOptions, setShouldShowMultipleOptions] = React.useState(false);
  return (
    <>
      <div className="row">
        {menuItems(isAdmin).map((item, idx) => (
          <div key={idx} className="col-3">
            <div className="more-menu-item">
              <div className="card">
                <a
                  href={item.to}
                  className="card-container"
                  target={item.target}
                  data-track-category={item.trackCategory}
                  data-track-action={item.trackAction}
                  data-track-label={item.trackLabel}
                >
                  <i className={item.icon}></i>
                  <span className="menu-label">{item.label}</span>
                </a>
              </div>
            </div>
          </div>
        ))}

        {isUserSignedIn && !isAlgoverse && (
          <div className="col-3">
            <div className="more-menu-item">
              <div className={`card ${currentUserTheme}`}>
                <div className="card-container" onClick={updateUserTheme}>
                  {currentUserTheme === 'light' ? (
                    <i className="fa-regular fa-sun-bright" />
                  ) : (
                    <i className="fa-regular fa-moon"></i>
                  )}
                  <span className="menu-label">Dark Theme</span>
                </div>
              </div>
            </div>
          </div>
        )}
        {!isB2b && (
          <>
            <div className="col-3">
              <div className="more-menu-item">
                <div className={`card ${currentUserTheme}`}>
                  <div
                    className="card-container"
                    onClick={() => setShouldShowMultipleOptions(!shouldShowMultipleOptions)}
                  >
                    <i className="fa-regular fa-headset" />
                    <span className="menu-label">Support</span>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-3">
              <div className="course-nav-link more-menu-item">
                <div className={`card ${currentUserTheme}`}>
                  <a className="card-container" href="#">
                    <i className="fa-regular fa-graduation-cap"></i>
                    <a
                      href="#"
                      className="nav-item track"
                      data-login-label="Course Login"
                      data-track-category="Nav-Bar"
                      data-track-action="Course Login"
                      data-track-label="Course Login"
                      onClick={(e) => {
                        e.preventDefault();
                        window.location.href = '/mycourse';
                      }}
                    >
                      Course
                    </a>
                  </a>
                </div>
              </div>
            </div> */}
          </>
        )}
      </div>

      <div className="modal-divider"></div>
      {shouldShowMultipleOptions && (
        <div className="more-options">
          <h6>Support</h6>
          <ul className="p-0 support-links">
            {_.map(supportConfig, (s, idx) => (
              <li key={idx}>
                <a href={s.anchor} target="blank">
                  {s.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default Body;
